<template>
  <div-box>
    <nav-bar left-arrow :title="'USDT' + $t('资产')" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      :url="'/api/v1/balanceLog/getList?balance_field=balance'" :data="{}">
      <div-padding padding="4vw">


        <div-card bg='#212748' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-text color='#fff' size='4vw'>{{ item.remark }}</div-text>
            <div-text color='#fff' size='4vw' v-if="item.amount * 1 > 0">
              +{{ item.amount }} USDT
            </div-text>
            <div-text color='#fff' size='4vw' v-else>
              {{ item.amount }} USDT
            </div-text>
          </div-flex>
          <van-divider style="margin:3vw 0" />


          <div-flex>
            <div-text color='#999' size='3.5vw'>
              {{ $t('时间') }}：{{ item.created_at }}</div-text>
            <div-text color='#20c595' size='3.5vw'>
              {{ [$t('待审核'), $t('通过'), $t('驳回'), $t('转账中')][item.status] }}
            </div-text>
          </div-flex>

          <div-flex left v-if="item.status == 2">
            <div-text color='#999999' size='3.5vw'>{{ $t('驳回原因') }}：</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ item.reason }}</div-text>
          </div-flex>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.up_down()
  },
  methods: {
  },
}
</script>
<style lang='less' scoped></style>